import { Account, AccountStatus, AccountType } from 'eve-account-client';

export const employer: Account = {
  id: '1',
  type: AccountType.EMPLOYER,
  status: AccountStatus.ACTIVE,
  companyInfo: {
    companyName: 'Mock Employer Account no Web Service',
    physicalLocation: {
      line1: '123 main st',
      city: 'Chicago',
      stateCode: 'IL',
      zipCode: '60601',
      countyId: 33221,
    },
  },
  mouSignatorId: '1',
  webServiceAccess: {
    enabled: false,
  },
};

export const employerWithWebService: Account = {
  id: '2',
  type: AccountType.EMPLOYER,
  status: AccountStatus.ACTIVE,
  companyInfo: {
    companyName: 'Mock Employer Account with Web Service',
    physicalLocation: {
      line1: '456 main st',
      city: 'Chicago',
      stateCode: 'IL',
      zipCode: '60601',
      countyId: 45332,
    },
  },
  mouSignatorId: '1',
  webServiceAccess: {
    enabled: true,
  },
};

export const agency: Account = {
  id: '3',
  type: AccountType.AGENCY,
  status: AccountStatus.ACTIVE,
  companyInfo: {
    companyName: 'Mock Agency Account no Web Service',
    physicalLocation: {
      line1: '789 main st',
      city: 'Chicago',
      stateCode: 'IL',
      zipCode: '60601',
      countyId: 88756,
    },
  },
  mouSignatorId: '1',
  webServiceAccess: {
    enabled: false,
  },
};

export const agencyWithWebService: Account = {
  id: '4',
  type: AccountType.AGENCY,
  status: AccountStatus.ACTIVE,
  companyInfo: {
    companyName: 'Mock Agency Account with Web Service',
    physicalLocation: {
      line1: '987 main st',
      city: 'Chicago',
      stateCode: 'IL',
      zipCode: '60601',
      countyId: 77645,
    },
  },
  mouSignatorId: '1',
  webServiceAccess: {
    enabled: true,
  },
};

export const corporate: Account = {
  id: '5',
  type: AccountType.CORPORATE,
  status: AccountStatus.ACTIVE,
  companyInfo: {
    companyName: 'Mock Corporate Account no Web Service',
    physicalLocation: {
      line1: '654 main st',
      city: 'Chicago',
      stateCode: 'IL',
      zipCode: '60601',
      countyId: 93462,
    },
  },
  mouSignatorId: '1',
  webServiceAccess: {
    enabled: false,
  },
};

export const corporateWithWebService: Account = {
  id: '6',
  type: AccountType.CORPORATE,
  status: AccountStatus.ACTIVE,
  companyInfo: {
    companyName: 'Mock Corporate Account with Web Service',
    physicalLocation: {
      line1: '321 main st',
      city: 'Chicago',
      stateCode: 'IL',
      zipCode: '60601',
      countyId: 10011,
    },
  },
  mouSignatorId: '1',
  webServiceAccess: {
    enabled: true,
  },
};

export const employerWithMyI9EnabledSigned: Account = {
  id: '7',
  type: AccountType.EMPLOYER,
  status: AccountStatus.ACTIVE,
  companyInfo: {
    companyName: 'Mock Employer Account no Web Service',
    physicalLocation: {
      line1: '123 main st',
      city: 'Chicago',
      stateCode: 'IL',
      zipCode: '60601',
      countyId: 33221,
    },
  },
  mouSignatorId: '1',
  webServiceAccess: {
    enabled: false,
  },
  myI9: {
    enabled: true,
    signedDate: new Date(),
  },
};

export const employerWithMyI9Disabled: Account = {
  id: '8',
  type: AccountType.EMPLOYER,
  status: AccountStatus.ACTIVE,
  companyInfo: {
    companyName: 'Mock Employer Account no Web Service',
    physicalLocation: {
      line1: '123 main st',
      city: 'Chicago',
      stateCode: 'IL',
      zipCode: '60601',
      countyId: 33221,
    },
  },
  mouSignatorId: '1',
  webServiceAccess: {
    enabled: false,
  },
  myI9: {
    enabled: false,
  },
};
